// Model.js
// -----------------------
// @module Case
define("BluePoint.OrderTotalFix.OrderTotalFix.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/OrderTotalFix/SuiteScript2/OrderTotalFix.Service.ss"
            ),
            true
        )
});
});
